import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import './ServicePage.css';

const PaymentIntegrations = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
    window.scrollTo(0, 0);
  }, []);

  const paymentGateways = [
    {
      name: 'Razorpay',
      features: [
        'Payment gateway integration',
        'Subscription management',
        'Refund processing',
        'Payment analytics'
      ]
    },
    {
      name: 'Stripe',
      features: [
        'Global payment processing',
        'Subscription billing',
        'Payment methods support',
        'Fraud prevention'
      ]
    },
    {
      name: 'Cashfree',
      features: [
        'Payment gateway setup',
        'UPI integration',
        'Wallet payments',
        'Bank transfers'
      ]
    },
    {
      name: 'PhonePe',
      features: [
        'UPI payments',
        'QR code payments',
        'Merchant integration',
        'Payment links'
      ]
    },
    {
      name: 'PayU',
      features: [
        'Payment gateway integration',
        'Multiple payment options',
        'International payments',
        'Recurring payments'
      ]
    },
    {
      name: 'Paytm',
      features: [
        'Wallet integration',
        'UPI payments',
        'Payment gateway',
        'Merchant solutions'
      ]
    }
  ];

  const generalFeatures = [
    'Secure payment processing',
    'Multiple payment methods',
    'Mobile & web integration',
    'Real-time transaction tracking',
    'Payment webhooks',
    'Refund management',
    'Payment analytics & reports',
    'PCI DSS compliance',
    'Error handling & retry logic',
    'Multi-currency support'
  ];

  return (
    <div className="service-page">
      <Navbar />
      <div className="service-hero">
        <Link to="/" className="back-button" data-aos="fade-right">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="service-hero-content" data-aos="fade-up">
          <h1 className="service-page-title">Payment Integrations</h1>
          <p className="service-hero-tagline">Seamless payment gateway integrations for secure and smooth transactions.</p>
        </div>
      </div>

      <div className="service-content">
        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Overview</h2>
          <p className="section-text">
            We integrate all major payment gateways to enable secure, fast, and reliable payment processing for your applications. 
            From Razorpay to Stripe, PhonePe to Paytm, we support all popular payment solutions used in India and globally.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Supported Payment Gateways</h2>
          <div className="payment-gateways-grid">
            {paymentGateways.map((gateway, index) => (
              <div key={index} className="gateway-card" data-aos="fade-up" data-aos-delay={index * 100}>
                <h3 className="gateway-name">{gateway.name}</h3>
                <ul className="gateway-features">
                  {gateway.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>
                      <FaCheck className="check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">What You Get</h2>
          <div className="features-grid">
            {generalFeatures.map((feature, index) => (
              <div key={index} className="feature-item" data-aos="fade-up" data-aos-delay={index * 50}>
                <FaCheck className="check-icon" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="service-cta" data-aos="fade-up">
          <Link to="/contact" className="cta-button-primary">
            Get Started →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentIntegrations;

